import { AvailabilityDto } from '../core/availabilities';
import { HttpClient } from './http';

export interface AvailabilityService {
  get: () => Promise<AvailabilityDto>;
  update: (data: Partial<AvailabilityDto>) => Promise<AvailabilityDto>;
}

export function createAvailabilityService(
  httpClient: HttpClient,
  baseUrl: string,
): AvailabilityService {
  return {
    get: () => {
      return httpClient<AvailabilityDto>(`${baseUrl}/availability`, 'get');
    },
    update: (data: Partial<AvailabilityDto>) => {
      return httpClient<AvailabilityDto>(`${baseUrl}/availability`, 'patch', {
        body: data,
      });
    },
  };
}
